import ErrorProcessingRequest from './Templates/ErrorProcessingRequest';

export default function ErrorHandler(error, setTemplate) {
  if (error.template) {
    setTemplate(error.template());
  } else {
    setTemplate(ErrorProcessingRequest());
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Errors/ErrorHandler.js